import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const texts = [
  "Sustainably caught and packed in Ecuador",
  "Peak freshness, firmness and flavor assured",
  "Authentically Ecuadorian, Proudly Australian"
];

function Hero() {

  const [currentIndex, setCurrentIndex] = useState(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % texts.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="/images/ecuador_coast.jpeg"
          alt="Ecuadorian Coast"
          className="w-full h-full object-cover brightness-50"
          referrerPolicy="no-referrer"
        />
      </div>
      <div className="relative z-10 text-center px-6 max-w-4xl">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="inline-block text-white/70 tracking-[0.3em] uppercase text-xs mb-6"
        >
          Direct from the Pacific Coast of Ecuador
        </motion.span>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-6xl md:text-8xl text-white font-serif mb-8 leading-tight"
        >
          The Gold of <br />
          <span className="italic">The Deep Blue</span>
        </motion.h1>
        <AnimatePresence mode="wait">
          <motion.p
            key={currentIndex}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 1 }}
            className="text-xl md:text-4xl text-white/80 font-serif mb-8 leading-tight"
          >
            {texts[currentIndex]}
          </motion.p>
        </AnimatePresence>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="flex flex-col md:flex-row items-center justify-center gap-6"
        >
          <a href="#about">
            <button className="px-10 py-4 border border-white/30 text-white tracking-widest uppercase text-xs font-bold hover:bg-white/10 transition-colors backdrop-blur-sm">
              Our Story
            </button>
          </a>
        </motion.div>
      </div>
      <motion.div
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/50"
      >
        <div className="w-[1px] h-12 bg-gradient-to-b from-white to-transparent mx-auto" />
      </motion.div>
    </section>
  );
}

export default Hero;
